import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { DiceItem } from "./records";

const slice = createEntitySlice<DiceItem>({
  name: "roomDiceSymbol",
});

export const { actions, reducer } = slice;
